import { Directive } from 'vue';

const visible: Directive<HTMLElement, boolean> = (el, binding) => {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
};

export default visible;
